import { useEffect, useState } from "react";
import { Map, AdvancedMarker, useMap } from "@vis.gl/react-google-maps";

function GoogleMaps({ bounds, setLink, searchPosition }) {
  const [markerPosition, setMarkerPosition] = useState(null);
  const map = useMap();

  // 🔥 smooth zoom
  const smoothZoom = (map, targetZoom, step = 1) => {
    const currentZoom = map.getZoom();
    if (currentZoom === targetZoom) return;

    const zoomIn = currentZoom < targetZoom;
    const nextZoom = zoomIn ? currentZoom + step : currentZoom - step;

    map.setZoom(nextZoom);

    setTimeout(() => smoothZoom(map, targetZoom, step), 60);
  };

  // 🔥 smooth przesuwanie
  const smoothPanTo = (map, target, duration = 800) => {
    const start = map.getCenter();
    const startLat = start.lat();
    const startLng = start.lng();

    const deltaLat = target.lat - startLat;
    const deltaLng = target.lng - startLng;

    const startTime = performance.now();

    const animate = (time) => {
      const progress = Math.min((time - startTime) / duration, 1);
      const ease = progress * (2 - progress);

      const lat = startLat + deltaLat * ease;
      const lng = startLng + deltaLng * ease;

      map.setCenter({ lat, lng });

      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  };

  // 🔥 główna animacja
  const animateToLocation = (map, target, type) => {
    const zoomLevels = {
      province: 7,
      district: 10,
      commune: 12,
      city: 14,
    };

    const targetZoom = zoomLevels[type] || 14;

    // 1. zoom-out
    // smoothZoom(map, 6);

    // 2. przelot
    setTimeout(() => {
      smoothPanTo(map, target);
    }, 300);

    // 3. zoom-in
    setTimeout(() => {
      smoothZoom(map, targetZoom);
    }, 1100);
  };

  // 📍 NIE RUSZAMY
  const handleMapClick = (event) => {
    const newPosition = {
      lat: event.detail.latLng.lat,
      lng: event.detail.latLng.lng,
    };
    setLink(`https://www.google.com/maps?q=${newPosition.lat},${newPosition.lng}`);
    setMarkerPosition(newPosition);
  };

  // bounds tylko jeśli brak wyboru
  useEffect(() => {
    if (map && bounds && !searchPosition) {
      map.fitBounds(bounds);
    }
  }, [map, bounds, searchPosition]);

  // 🔥 TU SIĘ DZIEJE MAGIA
  useEffect(() => {
    if (map && searchPosition) {

      animateToLocation(map, searchPosition, searchPosition.type);
    }
  }, [searchPosition, map]);

  return (
    <div id="map-form">
      <Map
        style={{ containerStyle: { width: "100%", height: "400px" }, borderRadius: 14 }}
        defaultCenter={{ lat: 52.2297, lng: 21.0122 }}
        defaultZoom={10}
        mapId="DEMO_MAP_ID"
        onClick={handleMapClick}
        mapTypeId="hybrid"
      >
        {markerPosition && (
          <AdvancedMarker
 
            position={markerPosition}
            title="Wybrana lokalizacja"
          >
            <div style={{ color: "red", fontWeight: "bold", fontSize: "32px" }}>📍</div>
          </AdvancedMarker>
        )}
      </Map>
    </div>
  );
}

export default GoogleMaps;